module.exports = __webpack_public_path__ + "img/home.c1b358b2.svg";